// @flow
import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

type Props = {
  show?: boolean,
  onHide: () => void,
  handleDelete: () => void
};

const ConfirmDeleteReferenceLayerModal = ({
  show,
  onHide,
  handleDelete,
  isDeleting
}: Props) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton disabled={isDeleting}>
      <Modal.Title>Confirm Reference Layer Delete</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {isDeleting ? (
        <p>Deleting reference layer, please wait</p>
      ) : (
        <p>This action is irreversible. Are you sure you want to proceed?</p>
      )}
      {/* TODO: disable on saving? */}
      <div className="modal--multi-buttons">
        <Button bsStyle="primary" onClick={handleDelete} disabled={isDeleting}>
          Delete
        </Button>
        <Button bsStyle="secondary" onClick={onHide} disabled={isDeleting}>
          Cancel
        </Button>
      </div>
    </Modal.Body>
  </Modal>
);

export default ConfirmDeleteReferenceLayerModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmDeleteReferenceLayerModal.js